import React, { useState } from "react";
import Admin from "../layout/Admin";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { createEbarimt, deleteEbarimt, sendEbarimt } from "../../actions/ebarimt";

const Ebarimt = ({ createEbarimt, deleteEbarimt, sendEbarimt, receipt, loading }) => {
  const [createForm, setCreateForm] = useState({ amount: "", pages: "" });
  const [deleteId, setDeleteId] = useState("");
  const [sendConfirm, setSendConfirm] = useState(false);

  const onCreateChange = (e) =>
    setCreateForm({ ...createForm, [e.target.name]: e.target.value });

  const onCreateSubmit = (e) => {
    e.preventDefault();
    createEbarimt({
      amount: parseInt(createForm.amount, 10),
      pages: parseInt(createForm.pages, 10),
    });
  };

  const onDeleteSubmit = (e) => {
    e.preventDefault();
    if (deleteId.trim()) {
      deleteEbarimt(deleteId.trim());
      setDeleteId("");
    }
  };

  const onSendData = () => {
    sendEbarimt();
    setSendConfirm(false);
  };

  return (
    <>
      <Admin>
        <h2 className="my-6 text-2xl font-semibold text-gray-700 dark:text-gray-200">
          И-баримт
        </h2>

        {/* Create Receipt */}
        <div className="px-4 py-5 mb-8 bg-white rounded-lg shadow-md dark:bg-gray-800">
          <h3 className="mb-4 text-lg font-semibold text-gray-700 dark:text-gray-200">
            Create Receipt
          </h3>
          <form onSubmit={onCreateSubmit}>
            <div className="flex flex-wrap gap-4 items-end">
              <div>
                <label className="block mb-1 text-sm text-gray-600 dark:text-gray-400">
                  Amount (₮)
                </label>
                <input
                  type="number"
                  name="amount"
                  value={createForm.amount}
                  onChange={onCreateChange}
                  min="1"
                  required
                  placeholder="e.g. 500"
                  className="block w-40 text-sm dark:text-gray-300 dark:border-gray-600 dark:bg-gray-700 border border-gray-300 rounded-lg px-3 py-2 focus:border-purple-400 focus:outline-none focus:ring-2 focus:ring-purple-200"
                />
              </div>
              <div>
                <label className="block mb-1 text-sm text-gray-600 dark:text-gray-400">
                  Pages
                </label>
                <input
                  type="number"
                  name="pages"
                  value={createForm.pages}
                  onChange={onCreateChange}
                  min="1"
                  required
                  placeholder="e.g. 1"
                  className="block w-32 text-sm dark:text-gray-300 dark:border-gray-600 dark:bg-gray-700 border border-gray-300 rounded-lg px-3 py-2 focus:border-purple-400 focus:outline-none focus:ring-2 focus:ring-purple-200"
                />
              </div>
              <button
                type="submit"
                disabled={loading}
                className="px-5 py-2 text-sm font-medium leading-5 text-white transition-colors duration-150 bg-purple-600 border border-transparent rounded-lg hover:bg-purple-700 focus:outline-none focus:ring-2 focus:ring-purple-200 disabled:opacity-60"
              >
                {loading ? "Creating..." : "Create"}
              </button>
            </div>
          </form>
        </div>

        {/* Receipt Result */}
        {receipt && (
          <div className="px-4 py-5 mb-8 bg-white rounded-lg shadow-md dark:bg-gray-800">
            <div className="flex items-center justify-between mb-4">
              <h3 className="text-lg font-semibold text-gray-700 dark:text-gray-200">
                Receipt Result
              </h3>
              <span className="inline-flex items-center px-3 py-1 text-xs font-medium text-green-700 bg-green-100 rounded-full dark:bg-green-800 dark:text-green-100">
                Success
              </span>
            </div>
            <div className="overflow-x-auto">
              <table className="w-full text-sm text-left text-gray-600 dark:text-gray-400">
                <tbody className="divide-y dark:divide-gray-700">
                  {Object.entries(receipt).map(([key, value]) => (
                    <tr key={key}>
                      <td className="py-2 pr-4 font-medium text-gray-700 dark:text-gray-300 capitalize w-1/3">
                        {key.replace(/_/g, " ")}
                      </td>
                      <td className="py-2 break-all">
                        {typeof value === "object"
                          ? JSON.stringify(value, null, 2)
                          : String(value)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        )}

        {/* Send Data */}
        <div className="px-4 py-5 mb-8 bg-white rounded-lg shadow-md dark:bg-gray-800">
          <h3 className="mb-2 text-lg font-semibold text-gray-700 dark:text-gray-200">
            Send E-Barimt Data
          </h3>
          <p className="mb-4 text-sm text-gray-500 dark:text-gray-400">
            Trigger data synchronization to the e-barimt service.
          </p>
          {!sendConfirm ? (
            <button
              onClick={() => setSendConfirm(true)}
              className="px-5 py-2 text-sm font-medium leading-5 text-white transition-colors duration-150 bg-blue-600 border border-transparent rounded-lg hover:bg-blue-700 focus:outline-none focus:ring-2 focus:ring-blue-200"
            >
              Send Data
            </button>
          ) : (
            <div className="flex items-center gap-3">
              <span className="text-sm text-gray-600 dark:text-gray-400">
                Confirm send?
              </span>
              <button
                onClick={onSendData}
                className="px-4 py-2 text-sm font-medium text-white bg-blue-600 rounded-lg hover:bg-blue-700 focus:outline-none"
              >
                Yes, Send
              </button>
              <button
                onClick={() => setSendConfirm(false)}
                className="px-4 py-2 text-sm font-medium text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 dark:bg-gray-700 dark:text-gray-300 focus:outline-none"
              >
                Cancel
              </button>
            </div>
          )}
        </div>

        {/* Delete Receipt */}
        <div className="px-4 py-5 mb-8 bg-white rounded-lg shadow-md dark:bg-gray-800">
          <h3 className="mb-2 text-lg font-semibold text-gray-700 dark:text-gray-200">
            Delete Receipt
          </h3>
          <p className="mb-4 text-sm text-gray-500 dark:text-gray-400">
            Enter the receipt ID to remove it from the e-barimt service.
          </p>
          <form onSubmit={onDeleteSubmit} className="flex items-end gap-4">
            <div>
              <label className="block mb-1 text-sm text-gray-600 dark:text-gray-400">
                Receipt ID
              </label>
              <input
                type="text"
                value={deleteId}
                onChange={(e) => setDeleteId(e.target.value)}
                required
                placeholder="Enter receipt ID"
                className="block w-64 text-sm dark:text-gray-300 dark:border-gray-600 dark:bg-gray-700 border border-gray-300 rounded-lg px-3 py-2 focus:border-red-400 focus:outline-none focus:ring-2 focus:ring-red-200"
              />
            </div>
            <button
              type="submit"
              className="px-5 py-2 text-sm font-medium leading-5 text-white transition-colors duration-150 bg-red-600 border border-transparent rounded-lg hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-red-200"
            >
              Delete
            </button>
          </form>
        </div>
      </Admin>
    </>
  );
};

Ebarimt.propTypes = {
  createEbarimt: PropTypes.func.isRequired,
  deleteEbarimt: PropTypes.func.isRequired,
  sendEbarimt: PropTypes.func.isRequired,
  receipt: PropTypes.object,
  loading: PropTypes.bool.isRequired,
};

const mapStateToProps = (state) => ({
  receipt: state.ebarimt.receipt,
  loading: state.ebarimt.loading,
});

export default connect(mapStateToProps, {
  createEbarimt,
  deleteEbarimt,
  sendEbarimt,
})(Ebarimt);
